import React from "react";
import { STATUS_LABELS, statusKleur } from "../../utils/dossierKleuren";

/**
 * Kleine statuspil voor dossierlijsten (Voltooid groen, Geannuleerd grijs).
 * Kleur en label komen uit utils/dossierKleuren, zodat status overal
 * hetzelfde oogt.
 */
export default function DossierStatusBadge({
  status,
  style,
}: {
  status: string;
  style?: React.CSSProperties;
}) {
  const kleur = statusKleur(status);
  return (
    <span
      style={{
        display: "inline-block",
        padding: "1px 8px",
        borderRadius: 9999,
        fontSize: 11,
        fontWeight: 600,
        lineHeight: "16px",
        whiteSpace: "nowrap",
        color: "var(--color-text, #111827)",
        background: `${kleur}26`,
        border: `1px solid ${kleur}`,
        ...style,
      }}
    >
      {STATUS_LABELS[status] ?? status}
    </span>
  );
}
